var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */
import { Component, Event, html, Prop, Watch } from '@sick-davinci/ce-decorators';
import { style } from './StateSequenceChart.style';
import { ColoredDataElement } from '../_utils/ColoredDataElement.js'; // should be imported first, so css variables from theme-base are available

import * as MeisterCharts from '@meistercharts/meistercharts';
import { ThemeService } from '../_utils/ThemeService.js';
import { CssTools } from '../_utils/CssTools.js';
import { resolveCssColor, toCssColorValue } from '../_utils/ColorTools.js';
import { TimeAxisBuilder } from '../_utils/TimeAxisBuilder.js';
import { ValueAxisBuilder } from '../_utils/ValueAxisBuilder.js';
import { sanitizeStateSequenceData, createEmptyData, computeDiscreteTimelineChartData } from './StateSequenceData.js';
import { createDefaultStateSequenceConfiguration, sanitizeStateSequenceConfigurations } from './StateSequenceConfiguration.js';
import { createBalloonTooltipStyle } from '../_utils/TooltipTools.js';
/**
 * A chart that displays time-based state-sequences with labels.
 *
 * This chart does not support zooming.
 *
 * @example
 * ```
 * <davinci-element-container heading="State Sequence Chart" style="width: 500px; height: 300px">
 *   <davinci-state-sequence-chart id="chart" state-sequence-configs='[
 *        {
 *         "label": "Switch valve",
 *         "stateConfigs": [
 *             { "label": "Open" },
 *             { "label": "Closed" }
 *           ]
 *       }]'></davinci-state-sequence-chart>
 * </davinci-element-container>
 * <script>
 *   const chart = document.getElementById('chart');
 *   chart.setData(
 *     {
 *       sequences: [
 *         {
 *           entries: [
 *             {
 *               start: 1680272629735,
 *               end: 1680272630735,
 *               label: 'Stumbled over switch',
 *               state: 0,
 *             },
 *             {
 *               start: 1680272630735,
 *               end: 1680272631735,
 *               label: 'Turned switch off',
 *               state: 1,
 *             }
 *           ]
 *         }
 *       ]
 *     }
 *   );
 * </script>
 * ```
 */

export let StateSequenceChart = (_dec = Component({
  tag: 'davinci-state-sequence-chart',
  style,
  dependencies: []
}), _dec2 = Prop({
  reflectAsAttribute: false
}), _dec3 = Reflect.metadata("design:type", String), _dec4 = Watch('timeAxisTitle'), _dec5 = Reflect.metadata("design:paramtypes", []), _dec6 = Prop({
  reflectAsAttribute: false
}), _dec7 = Reflect.metadata("design:type", Number), _dec8 = Watch('axisWidth'), _dec9 = Reflect.metadata("design:paramtypes", []), _dec10 = Prop({
  reflectAsAttribute: false
}), _dec11 = Reflect.metadata("design:type", Object), _dec12 = Watch('visibleSequences'), _dec13 = Reflect.metadata("design:paramtypes", []), _dec14 = Prop({
  reflectAsAttribute: false
}), _dec15 = Reflect.metadata("design:type", Object), _dec16 = Watch('stateSequenceConfigs'), _dec17 = Reflect.metadata("design:paramtypes", []), _dec18 = Event(), _dec19 = Reflect.metadata("design:type", Object), _dec20 = Prop({
  reflectAsAttribute: false
}), _dec21 = Reflect.metadata("design:type", Object), _dec22 = Watch('palette'), _dec23 = Reflect.metadata("design:paramtypes", []), _dec(_class = (_class2 = class StateSequenceChart extends ColoredDataElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "timeAxisTitle", _descriptor, this);

    _initializerDefineProperty(this, "axisWidth", _descriptor2, this);

    _initializerDefineProperty(this, "visibleSequences", _descriptor3, this);

    _defineProperty(this, "_stateSequenceConfigs", []);

    _initializerDefineProperty(this, "visibleTimeRangeChanged", _descriptor4, this);

    _defineProperty(this, "_data", createEmptyData());

    _defineProperty(this, "_themeListener", () => {
      this._update();
    });
  }

  _timeAxisTitleWatcher() {
    this._update();
  }
  /**
   * The width of the axis (in rem)
   *
   * @default ValueAxisBuilder.AXIS_DEFAULT_WIDTH
   */


  axisWidthWatcher() {
    this._update();
  }
  /**
   * The indices of the visible sequences.
   * If undefined, all sequences are visible.
   *
   * Example: `[2, 0, 5]` means that the third, first and sixth sequences is visible.
   */


  visibleSequencesWatcher() {
    this._update();
  }

  /**
   * The configurations used for the state-sequences
   */
  get stateSequenceConfigs() {
    return this._stateSequenceConfigs;
  }

  set stateSequenceConfigs(configs) {
    this._stateSequenceConfigs = sanitizeStateSequenceConfigurations(configs);

    this._update();
  }

  stateSequenceConfigsWatcher() {
    this._update();
  }
  /**
   * Emitted if the visible time range has changed
   */


  /**
   * The time range that is currently visible (read-only)
   * @readonly
   */
  get visibleTimeRange() {
    // If the api is ready return the current visible time range.
    if (this._api) {
      return this._api.getVisibleTimeRange();
    } // If the api is not ready yet return an empty time range.


    return {
      start: 0.0,
      end: 0.0
    };
  }
  /**
   * Update style if palette attribute changes
   */


  _paletteWatcher() {
    this._update();
  }

  /**
   * Sets the data (replaces the current data)
   */
  setData(data) {
    this.clear();
    this._data = sanitizeStateSequenceData(data);

    this._updateData();
  }
  /**
   * Clears the data
   */


  clear() {
    this._data = createEmptyData();

    if (this._api) {
      this._api.clearHistory();
    }
  }
  /**
   * Resets the translation
   */


  resetNavigation() {
    if (this._api) {
      this._api.resetView();
    }
  }

  _init() {
    var _this$shadowRoot;

    if (!this._api) {
      return;
    }

    const holder = (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.getElementById('holder');

    if (!holder) {
      return;
    }

    holder.appendChild(this._api.holder);

    this._update();

    this._updateData();
  }

  _updateData() {
    if (this._api === undefined) {
      return;
    }

    if (this._updateStateSequenceConfigsFromData(this._data)) {
      // update everything if the state-sequence configurations have changed
      this._update();
    }

    try {
      this._api.setHistory(computeDiscreteTimelineChartData(this._data));
    } finally {
      // Ensure that the stored data is cleared - even if an exception is thrown
      this._data = createEmptyData();
    }
  }
  /**
   * Updates the state-sequence configurations if needed.
   * Returns true if the configurations have been updated else false.
   */


  _updateStateSequenceConfigsFromData(data) {
    const oldLength = this.stateSequenceConfigs.length;

    while (this.stateSequenceConfigs.length < data.sequences.length) {
      this.stateSequenceConfigs.push(createDefaultStateSequenceConfiguration(this.stateSequenceConfigs.length));
    }

    return oldLength !== this.stateSequenceConfigs.length;
  }

  _update() {
    var _this$shadowRoot2, _this$visibleSequence;

    if (this._api === undefined) {
      return;
    }

    const host = (_this$shadowRoot2 = this.shadowRoot) === null || _this$shadowRoot2 === void 0 ? void 0 : _this$shadowRoot2.host;

    if (!host) {
      return;
    }

    const fontFamily = CssTools.GET_COMPUTED_FONT_FAMILY(host);

    this._api.setConfiguration({
      discreteStripeGap: CssTools.REM2PIXEL(0.5),
      discreteStripeHeight: CssTools.REM2PIXEL(1.5),
      discreteAxisStyle: this._computeDiscreteAxisStyle(fontFamily),
      timeAxisStyle: this._computeTimeAxisStyle(fontFamily),
      visibleDiscreteStripes: (_this$visibleSequence = this.visibleSequences) !== null && _this$visibleSequence !== void 0 ? _this$visibleSequence : [-1],
      discreteDataSeriesConfigurations: this._computeDiscreteDataSeriesConfigs(fontFamily),
      tooltipStyle: createBalloonTooltipStyle(fontFamily, false, 0)
    });
  }

  _computeDiscreteDataSeriesConfigs(fontFamily) {
    const stripeLabelFont = {
      family: fontFamily,
      size: CssTools.REM2PIXEL(0.75),
      style: 'normal',
      weight: 400 // regular

    };
    const fallbackLabelColor = resolveCssColor('var(--davinci-color-text-on-background)');
    return this.stateSequenceConfigs.map((config, index) => {
      var _config$stateConfigs;

      return {
        id: index,
        name: config.label,
        statusEnumConfiguration: config.stateConfigs === undefined ? null : {
          description: `enum-${index}`,
          values: config.stateConfigs.map((value, index) => ({
            ordinal: index,
            label: value.label
          }))
        },
        stripeLabelFont,
        stripeSegmentSeparatorWidth: 0.0,
        // disable separators
        stripeStyles: (_config$stateConfigs = config.stateConfigs) === null || _config$stateConfigs === void 0 ? void 0 : _config$stateConfigs.map((value, index) => {
          var _value$stripeStyle$ba, _value$stripeStyle, _value$stripeStyle$la, _value$stripeStyle2;

          return {
            backgroundColor: toCssColorValue((_value$stripeStyle$ba = (_value$stripeStyle = value.stripeStyle) === null || _value$stripeStyle === void 0 ? void 0 : _value$stripeStyle.backgroundColor) !== null && _value$stripeStyle$ba !== void 0 ? _value$stripeStyle$ba : index, this.palette),
            labelColor: toCssColorValue((_value$stripeStyle$la = (_value$stripeStyle2 = value.stripeStyle) === null || _value$stripeStyle2 === void 0 ? void 0 : _value$stripeStyle2.labelColor) !== null && _value$stripeStyle$la !== void 0 ? _value$stripeStyle$la : fallbackLabelColor, this.palette)
          };
        })
      };
    });
  }

  _computeTimeAxisStyle(fontFamily) {
    const timeAxisBuilder = new TimeAxisBuilder();
    timeAxisBuilder.fontFamily = fontFamily;
    timeAxisBuilder.title = this.timeAxisTitle;
    return timeAxisBuilder.build();
  }

  _computeDiscreteAxisStyle(fontFamily) {
    const valueAxisBuilder = new ValueAxisBuilder();
    valueAxisBuilder.fontFamily = fontFamily;
    valueAxisBuilder.horizontal = false;
    valueAxisBuilder.axisWidth = this.axisWidth;
    valueAxisBuilder.maxTickCount = 1000; // don't care

    valueAxisBuilder.shorthandLabels = false; // don't care

    const valueAxesStyle = valueAxisBuilder.build();
    return {
      backgroundColor: resolveCssColor('var(--davinci-color-background-elements-overlay)'),
      axisSize: valueAxesStyle.axisSize,
      axisLineColor: valueAxesStyle.axisLineColor,
      axisLineWidth: valueAxesStyle.axisLineWidth,
      tickFont: valueAxesStyle.tickFont,
      labelWrapMode: 'IfNecessary',
      tickLength: valueAxesStyle.tickLength,
      tickLabelColor: valueAxesStyle.tickLabelColor,
      tickLabelGap: valueAxesStyle.tickLabelGap
    };
  }
  /**
   * @override
   */


  componentFirstRender() {
    this._init();

    const holder = this.shadowRoot.getElementById('holder');
    holder.addEventListener('VisibleTimeRangeChanged', evt => {
      this.visibleTimeRangeChanged.emit(evt.detail);
    }, {
      passive: true
    });
  }
  /**
   * @override
   */


  render() {
    var _this$shadowRoot3;

    // recycle holder is needed: holds the actual chart as a child
    let holder = (_this$shadowRoot3 = this.shadowRoot) === null || _this$shadowRoot3 === void 0 ? void 0 : _this$shadowRoot3.getElementById('holder');

    if (!holder) {
      holder = document.createElement('div');
      holder.setAttribute('id', 'holder');
    }

    return html`<div class="inner">${holder}</div>`;
  }
  /**
   * @override
   */


  componentConnected() {
    super.componentConnected();
    ThemeService.GET_INSTANCE().addListener(this._themeListener);
    this._api = MeisterCharts.createDiscreteTimelineChart(); // this could be a reattach without a following call for componentFirstRender -> reestablish MeisterCharts API

    this._init();
  }
  /**
   * @override
   */


  componentDisconnected() {
    super.componentDisconnected();
    ThemeService.GET_INSTANCE().removeListener(this._themeListener); // We have been detached from the DOM -> clean up

    if (this._api) {
      this._api.holder.remove();

      this._api.dispose();
    }

    delete this._api;
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "timeAxisTitle", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "_timeAxisTitleWatcher", [_dec4, _dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "_timeAxisTitleWatcher"), _class2.prototype), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "axisWidth", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ValueAxisBuilder.AXIS_DEFAULT_WIDTH;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "axisWidthWatcher", [_dec8, _dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "axisWidthWatcher"), _class2.prototype), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "visibleSequences", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "visibleSequencesWatcher", [_dec12, _dec13], Object.getOwnPropertyDescriptor(_class2.prototype, "visibleSequencesWatcher"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "stateSequenceConfigs", [_dec14, _dec15], Object.getOwnPropertyDescriptor(_class2.prototype, "stateSequenceConfigs"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "stateSequenceConfigsWatcher", [_dec16, _dec17], Object.getOwnPropertyDescriptor(_class2.prototype, "stateSequenceConfigsWatcher"), _class2.prototype), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "visibleTimeRangeChanged", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "visibleTimeRange", [_dec20, _dec21], Object.getOwnPropertyDescriptor(_class2.prototype, "visibleTimeRange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_paletteWatcher", [_dec22, _dec23], Object.getOwnPropertyDescriptor(_class2.prototype, "_paletteWatcher"), _class2.prototype)), _class2)) || _class);
